import { useState, useEffect } from "react";
import { BaseCategorie } from "../../../../types/features/Post";
import { kafintech_products } from "../../../../constantes/kafintech-product";

interface CategorieFormProps {
  initialData?: Partial<BaseCategorie>;
  onSubmit: (data: BaseCategorie) => void;
  onCancel: () => void;
  isLoading: boolean;
  submitLabel: string;
  title: string;
}

export default function CategorieForm({ initialData, onSubmit, onCancel, isLoading, submitLabel }: CategorieFormProps) {
  const [formData, setFormData] = useState<BaseCategorie>({
    name: "",
    name_en: "",
    description: "",
    description_en: "",
    product_name: "all", // ✅ Valeur par défaut
    product_name_en: "all",
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        name: initialData.name || "",
        name_en: initialData.name_en || "",
        description: initialData.description || "",
        description_en: initialData.description_en || "",
        product_name: initialData.product_name || "all",
        product_name_en: initialData.product_name_en || "all",
      });
    }
  }, [initialData]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {/* 📦 Sélection du produit */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Produit concerné <span className="text-red-500">*</span>
        </label>
        <select
          name="product_name"
          value={formData.product_name || "all"}
          onChange={handleChange}
          required
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary"
        >
          <option value="all">Tous les produits</option>
          {kafintech_products.map((product) => (
            <option key={product.value} value={product.value}>
              {product.label}
            </option>
          ))}
        </select>
        <p className="text-xs text-gray-500 mt-1">
          Sélectionnez "Tous les produits" si cette catégorie concerne tous les produits
        </p>
      </div>

      {/* Français */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Nom (FR) <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary"
          placeholder="Ex: Business"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Description (FR)</label>
        <textarea
          name="description"
          value={formData.description || ""}
          onChange={handleChange}
          rows={3}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary"
          placeholder="Description en français"
        />
      </div>

      {/* Anglais */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Name (EN) <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          name="name_en"
          value={formData.name_en}
          onChange={handleChange}
          required
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary"
          placeholder="Ex: Business"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Description (EN)</label>
        <textarea
          name="description_en"
          value={formData.description_en || ""}
          onChange={handleChange}
          rows={3}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary"
          placeholder="Description in English"
        />
      </div>

      {/* Actions */}
      <div className="flex justify-end gap-3 pt-4">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
        >
          Annuler
        </button>
        <button
          type="submit"
          disabled={isLoading}
          className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors disabled:opacity-50"
        >
          {isLoading ? "Chargement..." : submitLabel}
        </button>
      </div>
    </form>
  );
}